    document.addEventListener("DOMContentLoaded", function () {
  const detailsContents = document.querySelectorAll(
    ".footer-block__details-content"
  );
  const headings = document.querySelectorAll(".footer-block__heading");

  headings.forEach((heading) => {
    heading.addEventListener("click", function () {
      const index = this.dataset.index - 1;
      const content = detailsContents[index];
      content.classList.toggle("active");
      content.style.maxHeight = content.classList.contains("active")
        ? content.scrollHeight + "px"
        : "0";
    });
  });
});